import { Box, Button, DialogContent, DialogTitle, Typography } from "@mui/material"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { BoundTextField } from "lib/@components/binding/bound-components"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function CopDocumentUploadDialog() {
    return (
        <DataInputDialog
            initialValue={{ name: "", fileName: null, fileData: null }}
            okLabel="Upload"
            okCaption="Upload PDF Document"
            okDisabled={isInvalid}
        >
            <DialogTitle>Upload PDF Document</DialogTitle>
            <DialogContent>
                <BoundTextField
                    field="name"
                    label="Document Name"
                    fullWidth
                    sx={{ mt: 1, mb: 2 }}
                    yup="string.trim.required"
                    autoFocus
                />
                <FilePicker />
            </DialogContent>
        </DataInputDialog>
    )
}

function FilePicker() {
    const { target, refresh } = useBoundContext()
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Button variant="outlined" component="label" startIcon={<Iconify icon="mdi:file-upload" />}>
                Choose PDF
                <input type="file" accept=".pdf" hidden onChange={handleFileChange} />
            </Button>
            <Typography variant="body2" color="text.secondary">
                {target.fileName ?? "No file selected"}
            </Typography>
        </Box>
    )

    function handleFileChange(e) {
        const file = e.target.files?.[0]
        if (!file) return
        const reader = new FileReader()
        reader.onload = () => {
            target.fileName = file.name
            target.fileData = reader.result
            refresh()
        }
        reader.readAsDataURL(file)
    }
}

function isInvalid(value) {
    return !value?.name?.trim() || !value?.fileData
}
